import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Impressum from "@/pages/Impressum";
import Admin from "@/pages/Admin";
import { LanguageProvider } from "@/lib/i18n";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    document.title = "MP Carrosserie — Präzision in Metall und Farbe | Wolfwil";
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Toaster position="top-right" theme="dark" />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
